/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ref_IntroInputs */

const en_formatter_ref_intro = /** @type {(inputs: Formatter_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each row is a real input and the exact output this tool produces. Only the last two rows change anything you would notice in your data.`)
};

const ko_formatter_ref_intro = /** @type {(inputs: Formatter_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 행은 실제 입력과 이 도구가 내놓는 정확한 출력입니다. 데이터에서 체감할 만한 변화가 있는 것은 마지막 두 행뿐입니다.`)
};

const ja_formatter_ref_intro = /** @type {(inputs: Formatter_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各行は実際の入力と、このツールが出す正確な出力です。データとして体感できる変化があるのは最後の 2 行だけです。`)
};

/**
* | output |
* | --- |
* | "Each row is a real input and the exact output this tool produces. Only the last two rows change anything you would notice in your data." |
*
* @param {Formatter_Ref_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ref_intro = /** @type {((inputs?: Formatter_Ref_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ref_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ref_intro(inputs)
	if (locale === "ko") return ko_formatter_ref_intro(inputs)
	return ja_formatter_ref_intro(inputs)
});